export default __webpack_public_path__ + "static/media/bus_c3.8737ceaf.svg";